import { crudRequest, crudRequest2, getSitePlan } from '@/services/api';
import { getSitePlanCounty, selectByParentCode } from '@/services/centerweightviewSiteNew';
import { getToDay } from '@/utils/date';
import moment from 'moment';

const paramsForm = {
  dateRange: getToDay(['YYYY-MM-DD 12:00:00', 'YYYY-MM-DD 11:59:59']),
  centerFilter: '',
  centerFilterCode: '',
  classityAreaName: '',
};

export default {
  namespace: 'centerWeightViewSiteNew',
  state: {
    dateRange: paramsForm.dateRange,
    centerFilter: paramsForm.centerFilter,
    centerFilterCode: paramsForm.centerFilterCode,
    classityAreaName: paramsForm.classityAreaName,
    defualtDateFormat: 'YYYY-MM-DD HH:mm:00',
    queriedCenterFilterCode: '',
    queriedClassityAreaName: '',
    sitePlan: [], // 上站已发
    isTmsLoading: false, // tms 接口是否加载完成
    actualDepartureCarsItem: [], // 已发出 tms
    planDepartureCarsItem: [], // 计划发
    volumeItem: [], // 运力
    sitePlanCountyList: {
      countyList: [],
      customCountyList: [],
    }, // 区县筛选项
    displayFlag: false,
  },
  effects: {
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      crudRequest('/api/route/centerWeightViewSiteNew/search');
      yield put({ type: 'centerWeightViewOutletsTablesNew/getSelect' });
    },
    *getTms(_, { call, put, select }) {
      // let sitePlanParams = yield select(({ centerWeightViewOutletsTablesNew,centerWeightViewSiteNew }) => ({
      //   preSiteFlag: centerWeightViewOutletsTablesNew.showPreSiteFlag? 1 : 0,
      //   departureCenterCode:centerWeightViewSiteNew.centerFilterCode,
      //   departureCenter: centerWeightViewSiteNew.centerFilter,
      //   startDate: moment(centerWeightViewSiteNew.dateRange[0]).format(centerWeightViewSiteNew.defualtDateFormat),
      //   endDate: moment(centerWeightViewSiteNew.dateRange[1]).format(centerWeightViewSiteNew.defualtDateFormat),
      // }));
      // tms
      yield put({
        type: 'update',
        payload: { isTmsLoading: false },
      });
      let query = yield select(({ centerWeightViewSiteNew }) => {
        return {
          locationName: centerWeightViewSiteNew.centerFilter,
          classityAreaName: centerWeightViewSiteNew.classityAreaName,
          startTime: moment(centerWeightViewSiteNew.dateRange[0]).format(
            centerWeightViewSiteNew.defualtDateFormat,
          ),
          endTime: moment(centerWeightViewSiteNew.dateRange[1]).format(
            centerWeightViewSiteNew.defualtDateFormat,
          ),
        };
      });
      const start = moment(query.startTime).day();
      const departure = yield call(crudRequest2, {
        period: start === 0 ? 7 : start,
        departureCenter: query.locationName,
        classityAreaName: query.classityAreaName,
      });
      // const sitePlan = yield call(getSitePlan, sitePlanParams)
      const volumeItem = departure.data && departure.data.length > 0 ? departure.data : [];
      yield put({
        type: 'update',
        payload: {
          // sitePlan: sitePlan?.data,
          isTmsLoading: true,
          volumeItem: volumeItem,
        },
      });
    },
    *getPreferencePub({ payload }, { call, put }) {
      const res = yield call(selectByParentCode, payload);
      if (res?.code == 1) {
        yield put({
          type: 'update',
          payload: { displayFlag: res?.data === 'true' || res?.data === true },
        });
      }
    },
    *getSitePlanCounty({ payload = {} }, { call, put, select }) {
      const params = yield select(
        ({ centerWeightViewOutletsTablesNew, centerWeightViewSiteNew }) => ({
          preSiteFlag: centerWeightViewOutletsTablesNew.showPreSiteFlag ? 1 : 0,
          destinationSiteFlag: centerWeightViewOutletsTablesNew.showDesSite ? 1 : 0,
          departureCenterCode: centerWeightViewSiteNew.centerFilterCode,
          departureCenter: centerWeightViewSiteNew.centerFilter,
          classityAreaName: centerWeightViewSiteNew.classityAreaName,
          startDate: moment(centerWeightViewSiteNew.dateRange[0]).format(
            centerWeightViewSiteNew.defualtDateFormat,
          ),
          endDate: moment(centerWeightViewSiteNew.dateRange[1]).format('YYYY-MM-DD HH:mm:59'),
        }),
      );
      const res = yield call(getSitePlanCounty, { ...params, ...payload });
      yield put({
        type: 'update',
        payload: {
          queriedCenterFilterCode: params.departureCenterCode || '',
          queriedClassityAreaName: params.classityAreaName || '',
          sitePlanCountyList: {
            countyList: res?.data?.countyList || [],
            customCountyList: res?.data?.customCountyList || [],
          },
        },
      });
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
